import report from './report/index';

import reactRenderer from './react-renderer';

reactRenderer.add(report);
